import React from 'react';

import Pagination from '../../../components/Pagination';
import AdListItem, { IPropsAdListItem } from '../components/AdListItem';

interface IPropsBookPageAdListTablePresenter {
  currentPage: number;
  pageLimit?: number;
  totalCount?: number;
  adLists?: IPropsAdListItem[];
  onChangePage: (page: number) => void;
  onCopyAdLink: (adId: string) => void;
}

const PAGE_LIMIT = 10;

const BookPageAdListTablePresenter = ({ adLists, pageLimit, totalCount, currentPage, onChangePage, onCopyAdLink }: IPropsBookPageAdListTablePresenter) => {
  return (
    <div className="overflow-x-auto overflow-y-hidden">
      <table className="table w-full">
        <thead>
          <tr>
            <th>Created At</th>
            <th>ID</th>
            <th>Book Title</th>
            <th>Chapter Title</th>
            <th>Note</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {adLists?.map((adList) => (
            <AdListItem {...adList} key={adList._id} onCopyAdLink={() => onCopyAdLink(adList._id)} />
          ))}
        </tbody>
      </table>

      <div className="flex items-center justify-between mt-12">
        <span className="text-systemGrays02LabelSecondary">แสดงผล 10 รายการต่อหน้า</span>

        {(totalCount || 0) > 1 && <Pagination currentPage={currentPage} totalCount={totalCount || 0} pageSize={pageLimit || PAGE_LIMIT} onPageChange={onChangePage} />}
      </div>
    </div>
  );
};

export default BookPageAdListTablePresenter;
